import { App, DirectiveBinding, VNode } from 'vue'
import Tracker from '@nio-fe/nio-tracker-web'
// import { Env } from '@loca/mfe-utils'
import { getEnv } from '@nio-wad/hooks'
const env = getEnv()
const project = env === 'prod' ? 'nioapp_prod' : 'nioapp_test'
Tracker.init(
  { appId: 100119 },
  {
    // 初始配置（详细配置请参考【二、参数规范-初始配置】）
    project,
    show_log: env !== 'prod', // 是否开启调试
  }
)

export default ({ app }: { app: App<any> & { $tracker: typeof Tracker } }) => {
  const handlers = new WeakMap()
  app.directive('tracker', {
    beforeMount: function (
      el: HTMLElement,
      binding: DirectiveBinding<{ name: string; type: string }>,
      vnode: VNode
    ) {
      const { name, type, ...params } = binding.value
      if (type) {
        const ref = vnode?.ref
        const inst = (ref instanceof Array ? ref?.[0].i : ref?.i)?.vnode
        const onChange = inst?.props?.onChange
        Object.assign(inst?.props, {
          onChange: (...args: any[]) => {
            const result = onChange?.(...args)
            if (result) {
              Tracker.track(name, result)
            }
          },
        })
        Tracker.track(name, params)
        return
      }
      const eventHandler = () => {
        Tracker.track(name, params)
      }
      handlers.set(el, eventHandler)
      el.addEventListener('click', eventHandler)
    },
    unmounted: function (el: HTMLElement) {
      const handler: (event: Event) => void = handlers.get(el)
      if (handler) {
        el.removeEventListener('click', handler)
        handlers.delete(el)
      }
    },
  })
}
